import {redirect} from '@tanstack/react-router';
import {addMinutes} from 'date-fns';
import Cookies from 'universal-cookie';
import {LOGIN} from '@/anonymous/routing/paths';
import {REDIRECT_TO} from '@/shared/const/cookies';
import {LOGOUT} from './paths';

export default function handleRedirectCookie({
  isLoggedIn,
  pathname
}: {
  isLoggedIn: boolean;
  pathname: string;
}) {
  const cookies = new Cookies();
  if (!isLoggedIn && pathname !== LOGOUT) {
    const expires = addMinutes(new Date(), 30);
    cookies.set(REDIRECT_TO, location.pathname, {expires});
    throw redirect({to: LOGIN, replace: true});
  } else if (isLoggedIn) {
    cookies.remove(REDIRECT_TO);
  }
}
